import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  Button,
  AppBar,
  Toolbar,
  IconButton,
  RaisedButton,
} from 'material-ui';
import LockClosedIcon from 'material-ui/svg-icons/action/lock';
import LockOpenIcon from 'material-ui/svg-icons/action/lock-open';
import injectSheet from 'react-jss';
import { push as routerPush } from 'react-router-redux';

const styles = {
  dialogContent: {
    width: '100% !important',
    maxWidth: 'none !important',
    transform: 'none !important',
  },
  dialogBody: {
    height: 'calc(100vh - 64px)',
    padding: '0 !important',
    maxHeight: 'none !important',
    // height: '100%',
  },
  dialogRoot: {
    paddingTop: '0 !important',
  }
};

const Wall = ({
  blocker,
  classes: css,
  open,
  plan,
  push,
  setOpen,
  skipBack,
  trackEvent,
  url,
}) => {
  if (!open || plan !== 'basic') return null;
  const handleClose = () => {
    if (blocker) {
      if (!skipBack) {
        window.history.back();
        setTimeout(() => { setOpen(false); }, 1e3);
      } else {
        setOpen(false);
      }
      // wait for the browser to load the prev screen
    } else {
      setOpen(false);
    }
  };
  const slug = url.split('/').pop();
  const handleUpgrade = () => {
    trackEvent({ name: '[Wall] Upgrade Click', ga: {
      eventCategory: 'account',
      eventAction: 'creditCardOpen',
      eventValue: slug,
    }});
    push('/upgrade');
    setTimeout(() => { setOpen(false); }, 1e3);
  }
  const handleFrameLoad = () => {
    trackEvent({ name: `[Wall] Opened ${slug}`, ga: {
      eventCategory: 'account',
      eventAction: 'wallOpen',
      eventValue: slug,
    }});
  };
  const titleTxt = (() => {
    if (slug === 'upgrade-general' || blocker) return (
      <span>Upgrade today for access to premium features.<br />
      Your contributions help us build great new features. Become a contributor, today!</span>
    );
    return (
      <span>
        <strong>Good news!</strong> While this is one of our premium features,&nbsp;
        <strong>we’ve unlocked it for you!</strong><br />
      Upgrade today to support more features like this.</span>
    );
  })();
  const LockIcon = blocker ? LockClosedIcon : LockOpenIcon;
  const title = (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '64px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <LockIcon style={{ width: '26px', height: '26px', color: 'white' }} />
        <p style={{ marginLeft: '1em', paddingTop: '0', marginBottom: '0', fontSize: '1rem', color: 'white'  }}>{titleTxt}</p>
      </div>
      <div>
        <RaisedButton
          backgroundColor="#FFC107"
          labelColor="black"
          label="Upgrade Now"
          labelStyle={{ fontWeight: 'bold' }}
          buttonStyle={{ lineHeight: 'none' }}
          onTouchTap={handleUpgrade}
          style={{ marginRight: '1em' }}
        />
        <RaisedButton
          label="No, thank you"
          buttonStyle={{ lineHeight: 'none' }}
          onTouchTap={handleClose}
        />
      </div>
    </div>
  );
  return (
    <Dialog
      style={{ zIndex: 2101 }}
      className={css.dialogRoot}
      open={open}
      onRequestClose={handleClose}
      title={title}
      titleStyle={{ backgroundColor: '#00bcd4', color: 'white' }}
      contentClassName={css.dialogContent}
      bodyClassName={css.dialogBody}
    >
      <iframe src={ url } width='100%' height='100%' title="Upgrade Promo" onLoad={handleFrameLoad}/>
    </Dialog>
  );
};
/*
*onClick={handleCose} />
*/
/*
      <div style={{ backgroundColor: 'rgb(250, 250, 250)', position: 'fixed', top: 0, left: 0, height: '100%', width: '100%', zIndex: 1350 }}>
        <iframe src={ url } width='100%' height='100%' title="Upgrade Promo"/>
      </div>
*/
export default connect(
  ({ walls: { open, url, blocker, skipBack }, user }) => ({
    open, url, blocker, skipBack, plan: user.getIn(['company', 'plan']) || 'basic',
  }),
  {
    setOpen: payload => ({
      type: '[wall] openClose',
      payload,
    }),
    trackEvent: payload => ({
      type: 'TRACK_EVENT',
      payload, 
    }),
    push: routerPush,
  },
)(injectSheet(styles)(Wall));



// WEBPACK FOOTER //
// ./src/app/components/wall/index.js